import { useState, useEffect } from "react";

import { WebinarsList } from "./components/WebinarsList";
import { Access } from "../components/ui/Access";
import { BottomCTA } from "../components/ui/BottomCTA";
import { InfoBox } from "../components/form/InfoBox";

import { webinar } from "../../datasets/webinars";

import TitleSection from "./components/TitleSection";

export const Webinars = ({ data }) => {
  const [attentionBox, setAttentionBox] = useState(false);

  useEffect(() => {
    if (window.location.state) {
      const isInfoboxPresent = window.location.state.infobox;
      if (isInfoboxPresent) setAttentionBox(true);
    }
  }, []);

  return (
    <>
      {attentionBox && <InfoBox closeModal={() => setAttentionBox(false)} type="Attention" />}
      <TitleSection title={data.title} />
      <section className="webinars-main">
        <WebinarsList webinars={data.webinars} title={data.title} loading={false} />
      </section>
      <Access skewed />
      <BottomCTA data={webinar.bottomCTA} />
    </>
  );
};
